import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  selectAiLoading,
  selectAiError,
  selectAiData,
  selectAiModel,
  selectAiScenes,
  selectPrompt,
} from '../store/ai.selector';
import {
  requestActions,
  requestObjects,
  requestScenes,
  setAiModel,
  setPrompt,
} from '../store/ai.actions';
import { AiData } from '../store/ai.reducer';

@Component({
  selector: 'nw-ai-panel',
  templateUrl: './ai-panel.component.html',
  styleUrls: ['./ai-panel.component.scss'],
})
export class AiPanelComponent {
  loading$: Observable<boolean>;
  error$: Observable<string | undefined>;
  data$: Observable<any>;
  prompt$: Observable<string | undefined>;
  model$: Observable<'openai' | 'claude'>;
  scenes$: Observable<AiData['scenes']>;

  constructor(private store: Store) {
    this.loading$ = this.store.select(selectAiLoading);
    this.error$ = this.store.select(selectAiError);
    this.data$ = this.store.select(selectAiData);
    this.model$ = this.store.select(selectAiModel);
    this.scenes$ = this.store.select(selectAiScenes);

    this.prompt$ = this.store.select(selectPrompt);

    this.scenes$.subscribe(scenes => {
      console.log('------- scenes', scenes);
    });
  }

  onPromptChange(event: Event) {
    const value = (event.target as HTMLTextAreaElement).value;
    this.store.dispatch(setPrompt({ prompt: value }));
  }

  onModelChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value as
      | 'openai'
      | 'claude';
    this.store.dispatch(setAiModel({ model: value }));
  }

  onGenerateScenes() {
    const prompt = (document.querySelector('textarea') as HTMLTextAreaElement)
      .value;
    this.store.dispatch(requestScenes({ prompt }));
  }

  onGenerateObjects() {
    const prompt = (document.querySelector('textarea') as HTMLTextAreaElement)
      .value;
    this.store.dispatch(requestObjects({ prompt }));
  }

  onGenerateActions() {
    const prompt = (document.querySelector('textarea') as HTMLTextAreaElement)
      .value;
    this.store.dispatch(requestActions({ prompt }));
  }
}
